import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Facebook, Instagram, Youtube, Twitter, MessageCircleWarning } from "lucide-react"; // ضفت أيقونة الشكاوي
import { Link } from "react-router-dom"; // عشان اللينك الداخلي
import "../../assets/styles/footer.css";

function Footer() {
  const socialIcons = [
    { icon: <Facebook size={18} />, link: "#Facebook" },
    { icon: <Instagram size={18} />, link: "#Instagram" },
    { icon: <Twitter size={18} />, link: "#Twitter" },
    { icon: <Youtube size={18} />, link: "#Youtube" },
  ];

  const sitemapLinks = [
    { name: "Start Page", path: "/" },
    { name: "Categories", path: "/activities/categories" }, 
    { name: "My activities", path: "/activities/my-activities" },
    { name: "My Points", path: "/user/profile/pointsHistory" }, 
    { name: "settings", path: "/user/settings" },   
  ];

  const legalLinks = [
    { name: "Privacy Policy", path: "/privacy" },
    { name: "Terms & Conditions", path: "/terms" },
  ];

  return (
    <footer className="footer-advanced">
      
      {/* SVG Wave Separator */}
      <div className="footer-wave-svg">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{width: '100%', height: '60px', display: 'block'}}>
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" 
            className="footer-wave-path"></path>
        </svg>
      </div>

      <Container className="position-relative z-2">
        <Row className="gy-5">
          
          {/* === Column 1: Brand & About === */}
          <Col lg={4} md={6} sm={12}>
            <div className="footer-logo-box">
              <img
                src="/CampusPulsLogo.png"
                alt="CampusPulse Logo"
                style={{ width: "120px", objectFit: "contain" }}
              />
            </div>
            <p className="footer-desc">
              CampusPulse is your gateway to a vibrant university life. 
              Connect, participate, and grow with a community that shares your passion.
            </p>
            <div className="d-flex gap-3 mt-4">
              {socialIcons.map((item, index) => (
                <a
                  key={index}
                  href={item.link}
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </Col>

          {/* === Column 2: Quick Links === */}
          <Col lg={2} md={3} sm={6}>
            <h5 className="footer-heading">Sitemap</h5>
            <ul className="list-unstyled m-0">
              {sitemapLinks.map((link, i) => (
                <li key={i} className="footer-link-item">
                  <Link to={link.path} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* === Column 3: Legal === */}
          <Col lg={2} md={3} sm={6}>
            <h5 className="footer-heading">Legal</h5>
            <ul className="list-unstyled m-0">
              {legalLinks.map((link, i) => (
                <li key={i} className="footer-link-item">
                  <Link to={link.path} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* === Column 4: Support & Complaints (NEW) === */}
          <Col lg={4} md={12} sm={12}>
            <h5 className="footer-heading">Need Help?</h5>
            <p className="footer-desc mb-3">
              Facing an issue or have a suggestion? We are here to listen and help you.
            </p>
            
            {/* زرار الشكاوي الجديد */}
            <div className="mt-3">
                <Link to="/ReportProblem" className="footer-btn-complaint text-decoration-none d-flex align-items-center justify-content-center gap-2">
                    <MessageCircleWarning size={20} />
                    Report a Problem
                </Link>
            </div>
          </Col>
        </Row>

        {/* === Copyright Section === */}
        <Row>
          <Col className="text-center">
            <div className="footer-copyright">
              <p className="m-0">
                © {new Date().getFullYear()} <span style={{color: '#fff', fontWeight: '600'}}>CampusPulse</span>. All rights reserved. 
                <span className="d-none d-sm-inline"> | Designed for Students.</span>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import { Facebook, Instagram, Youtube, Twitter } from "lucide-react";
// import "../../assets/styles/footer.css";

// function Footer() {
//   const socialIcons = [
//     { icon: <Facebook size={20} />, link: "https://facebook.com" },
//     { icon: <Instagram size={20} />, link: "https://instagram.com" },
//     { icon: <Twitter size={20} />, link: "https://twitter.com" },
//     { icon: <Youtube size={20} />, link: "https://youtube.com" },
//   ];

//   const sitemapLinks = ["Home", "Categories", "My Registrations", "New"];
//   const legalLinks = ["Privacy Policy", "Refund Policy", "Terms & Conditions"];

//   return (
//     <footer
//       style={{
//         background: "#1072B3",
//         color: "#fff",
//         paddingTop: "50px",
//         paddingBottom: "25px",
//         position: "relative",
//         bottom: 0,
//         width: "100%",
//       }}
//     >
//       <Container>
//         <Row className="gy-4 align-items-start">
//           {/* === Column 1: Logo === */}
//           <Col
//             md={3}
//             sm={12}
//             className="text-center text-md-start d-flex justify-content-md-start justify-content-center"
//           >
//             <img
//               src="/CampusPulsLogo.png"
//               alt="CampusPulse Logo"
//               style={{
//                 width: "160px",
//                 height: "160px",
//                 objectFit: "contain",
//                 backgroundColor: "rgba(255, 255, 255, 0.85)", // خلفية فاتحة شبه شفافة
//                 borderRadius: "12px", // زوايا ناعمة
//                 padding: "10px", // مساحة بسيطة حوالين اللوجو
//                 boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)", // ظل خفيف يرفع اللوجو شوية
//               }}
//             />
//           </Col>

//           {/* === Column 2: About Text === */}
//           <Col md={3} sm={12}>
//             <p
//               style={{
//                 fontSize: "0.95rem",
//                 opacity: 0.9,
//                 lineHeight: "1.7",
//                 margin: 0,
//               }}
//             >
//               We are a student community platform that helps you explore your
//               passions, join activities, and connect with like-minded peers. Our
//               goal is to make campus life more inspiring, creative, and fun.
//             </p>
//           </Col>

//           {/* === Column 3: Sitemap === */}
//           <Col md={3} sm={6}>
//             <h6 className="fw-bold border-bottom pb-2 mb-3">SITEMAP</h6>
//             <ul className="list-unstyled m-0">
//               {sitemapLinks.map((label, i) => (
//                 <li
//                   key={i}
//                   className="mb-2"
//                   style={{
//                     cursor: "pointer",
//                     transition: "0.3s",
//                     color: "white",
//                   }}
//                   onMouseOver={(e) => (e.target.style.color = "#00d4ff")}
//                   onMouseOut={(e) => (e.target.style.color = "white")}
//                 >
//                   › {label}
//                 </li>
//               ))}
//             </ul>
//           </Col>

//           {/* === Column 4: Social Media === */}
//           <Col md={3} sm={6}>
//             <h6 className="fw-bold border-bottom pb-2 mb-3">LEGAL</h6>
//             <ul className="list-unstyled m-0">
//               {legalLinks.map((label, i) => (
//                 <li
//                   key={i}
//                   className="mb-2"
//                   style={{
//                     cursor: "pointer",
//                     transition: "0.3s",
//                     color: "white",
//                   }}
//                   onMouseOver={(e) => (e.target.style.color = "#00d4ff")}
//                   onMouseOut={(e) => (e.target.style.color = "white")}
//                 >
//                   › {label}
//                 </li>
//               ))}
//             </ul>

//             <h6 className="fw-bold border-bottom pb-2 mb-3 mt-4">
//               CONNECT WITH US
//             </h6>
//             <div
//               className="d-flex gap-3 justify-content-md-start justify-content-center flex-wrap"
//               style={{ marginTop: "10px" }}
//             >
//               {socialIcons.map((item, index) => (
//                 <a
//                   key={index}
//                   href={item.link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{
//                     color: "white",
//                     background: "rgba(255,255,255,0.1)",
//                     borderRadius: "50%",
//                     padding: "10px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     transition: "all 0.3s ease",
//                     textDecoration: "none",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = "#00d4ff";
//                     e.currentTarget.style.color = "#0d47a1";
//                     e.currentTarget.style.transform = "scale(1.15)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = "rgba(255,255,255,0.1)";
//                     e.currentTarget.style.color = "white";
//                     e.currentTarget.style.transform = "scale(1)";
//                   }}
//                 >
//                   {item.icon}
//                 </a>
//               ))}
//             </div>
//           </Col>
//         </Row>

//         {/* === Copyright === */}
//         <hr
//           style={{ borderColor: "rgba(255,255,255,0.2)", marginTop: "40px" }}
//         />
//         <p
//           className="text-center m-0"
//           style={{ fontSize: "0.85rem", opacity: 0.8 ,backgroundColor:"#115481" }}
//         >
//           © {new Date().getFullYear()} CampusPulse. All rights reserved.
//         </p>
//       </Container>
//     </footer>
//   );
// }

// export default Footer;
